import LazyLoading from '../global/lazyLoading';
import OCM from '../global/off-canvas-menu';
import Header from '../global/header.js';
import AnchorTags from '../global/anchor-tags';
import Modals from '../util/Modals';
import EventFilter from '../global/event-filters';
export default {
	init() {
		LazyLoading.init();
		OCM.init();
		Header.init();
		AnchorTags.init();
		Modals.setupModals();
		EventFilter.init();
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	}
};
